import React, { useState } from 'react';
import RecordingModal from './RecordingModal';

// ─────────────────────────────────────────────────────────────────────────────
// RecordingButton — "View recording" for one interview round.
//
// Shown only when there is something to look for: the round had a Teams
// meeting and its slot is over. Before that the button would only ever say
// "not yet". Round date/time are IST, like everywhere else in the app.
// ─────────────────────────────────────────────────────────────────────────────

const IST_OFFSET_MIN = 330;

export const roundHasEnded = (round, now = Date.now()) => {
  const dm = String(round?.date || '').slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!dm) return false;
  const tm = String(round?.time || '').match(/^(\d{1,2}):(\d{2})/);
  const em = String(round?.endTime || '').match(/^(\d{1,2}):(\d{2})/);
  const start = Date.UTC(+dm[1], +dm[2] - 1, +dm[3], tm ? +tm[1] : 0, tm ? +tm[2] : 0) - IST_OFFSET_MIN * 60000;
  let duration = 60 * 60000;
  if (tm && em) {
    const d = ((+em[1]) * 60 + (+em[2]) - ((+tm[1]) * 60 + (+tm[2]))) * 60000;
    if (d > 0) duration = d;
  }
  const end = tm ? start + duration : start + 24 * 60 * 60000;
  return now > end;
};

export default function RecordingButton({ submissionId, round, label, stopPropagation = true, className = '' }) {
  const [open, setOpen] = useState(false);
  if (!submissionId || !round?.meetingLink || !roundHasEnded(round)) return null;

  const known = Array.isArray(round.recordings) && round.recordings.length > 0;
  const swallow = (e) => { if (stopPropagation) e.stopPropagation(); };

  return (
    <>
      <button
        type="button"
        className={`rec-btn${known ? ' is-known' : ''} ${className}`.trim()}
        onClick={(e) => { swallow(e); setOpen(true); }}
        onKeyDown={swallow}
        title={known ? 'Watch the Teams recording of this round' : 'Look for the Teams recording of this round'}
      >
        <span className="rec-btn__dot" aria-hidden="true" />
        {label || 'View recording'}
      </button>
      {/* The modal renders through a portal, but React events still bubble up
          this tree — straight into the clickable round row underneath. The
          boundary swallows them; display:contents keeps it out of the layout. */}
      {open && (
        <span style={{ display: 'contents' }} onClick={swallow} onKeyDown={swallow}>
          <RecordingModal isOpen onClose={() => setOpen(false)} submissionId={submissionId} round={round} />
        </span>
      )}
    </>
  );
}
